/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Represents an item for recently viewed.
 */
export abstract class RecentlyViewedItem<ItemId> {
    public readonly itemId: ItemId;

    public constructor(itemId: ItemId) {
        this.itemId = itemId;
    }
}
